import React from "react";
import PropTypes from "prop-types";
import "./index.less";
import Swiper from 'swiper/dist/js/swiper';
import "swiper/dist/css/swiper.css";

class Carousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: `swiper_${this.generateUUID()}`
    }
  }

  componentWillUpdate(prevProps, prevState) {
    if(prevProps !== this.props) {
      this.handleResetSwiper()
    }
  }

  componentDidMount() {
    this.handleResetSwiper();
  }

  generateUUID() {
    let d = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = (d + Math.random()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x7|0x8)).toString(16);
    });
    return uuid;
  }

  handleResetSwiper() {
    const { autoplay, direction, slidesPerView, slidesPerColumn } = this.props;
    const { id } = this.state;
    const params = {
      direction: direction,
      slidesPerView: slidesPerView,
      slidesPerColumn: slidesPerColumn,
      navigation: { 
        nextEl: '.swiper-button-next', 
        prevEl: '.swiper-button-prev'
      },
      autoplay: autoplay ? { delay: 3000 } : undefined,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
      },
      observer: true,
      observeParents: true,
      observeSlideChildren: true
    }
    new Swiper(`#${id}`, params);
  }

  render() {
    const { datas, border, slidesPerColumn, pagination, navigation } = this.props;
    const { id } = this.state;
    return (
      <div className="weax-iconblock-carousel">
        <div id={id} className="swiper-container">
          <div className="swiper-wrapper">
            { 
              slidesPerColumn > 1
              ? datas.map((data, index) => <CarouselMultiRow key={index} data={data} border={border} />) 
              : datas.map((data, index) => <CarouselSingleRow key={index} data={data} />)
            }
          </div>
          {
            pagination && <div className="swiper-pagination"></div>
          }
          { 
            navigation &&
            <React.Fragment>
              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
            </React.Fragment>
          }
        </div>
      </div>
    );
  }
}

// 轮播图样式-多行
const CarouselMultiRow = (props) => {
  const { data, border } = props;
  const slideClass = "swiper-slide weax-iconblock-carousel-temp multiRow" + (border ? ' weax-iconblock-carousel-border' : '');
  return (
    <div className={slideClass}>
      <img className="weax-iconblock-carousel-icon" src={data.img}/>
      <h3 className="weax-iconblock-carousel-title">{data.title}</h3>
    </div>
  )
}

// 轮播图样式-2
const CarouselSingleRow = (props) => {
  const { data } = props;
  return (
    <div className="swiper-slide weax-iconblock-carousel-temp singleRow">
      <img className="weax-iconblock-carousel-icon" src={data.img}/>
      <h3 className="weax-iconblock-carousel-title">{data.title}</h3>
      <p className="weax-iconblock-carousel-descript">{data.descript}</p>
    </div>
  )
}

Carousel.defaultProps = {
  templete: 'temp1',
  direction: 'horizontal',
  navigation: false,
  pagination: true,
  autoplay: true,
  border: false,
  slidesPerView: 3,
  slidesPerColumn: 1,
  datas: [
    {
      title: '元素小标题1',
      img: 'https://jdc.jd.com/img/200',
      descript: '王除弟严骨优半琴险都举。知编余蒙先玩血？',
      link: 'https://www.weaver.com.cn/'
    },
    {
      title: '元素小标题2',
      img: 'https://jdc.jd.com/img/200',
      descript: '帝清责盖香救调影道汽望馆开先？统富梦床？',
      link: 'https://www.weaver.com.cn/'
    },
    {
      title: '元素小标题3',
      img: 'https://jdc.jd.com/img/200',
      descript: '雪定妈色音未增己点细数上神凡父？清喜其。',
      link: 'https://www.weaver.com.cn/'
    },
    {
      title: '元素小标题4',
      img: 'https://jdc.jd.com/img/200',
      descript: '几者验蜖妻交南老午古来！车看排希表右客。',
      link: 'https://www.weaver.com.cn/'
    },
    {
      title: '元素小标题5',
      img: 'https://jdc.jd.com/img/200',
      descript: '最年思谁把叶财珍拥去原公某坦局迷狗。答。',
      link: 'https://www.weaver.com.cn/'
    },
    {
      title: '元素小标题6',
      img: 'https://jdc.jd.com/img/200',
      descript: '交供细归运胜创断场伴！破事降照计量普慢？',
      link: 'https://www.weaver.com.cn/'
    },
    {
      title: '元素小标题7',
      img: 'https://jdc.jd.com/img/200',
      descript: '认套话烟记母河朝回负。方比耳警洋价紶感？',
      link: 'https://www.weaver.com.cn/'
    },
    {
      title: '元素小标题8',
      img: 'https://jdc.jd.com/img/200',
      descript: '条克近基杀罪英他还钱华更蒙醒势息员候？。',
      link: 'https://www.weaver.com.cn/'
    }
  ]
};

Carousel.propTypes = {
  /** 模板类型 */
  templete: PropTypes.string,
  /** 走马灯滚屏方向 */
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  /** 是否显示左右指向箭头 */
  navigation: PropTypes.bool,
  /** 是否显示指示小圆点 */
  pagination: PropTypes.bool,
  /** 是否自动滚屏 */
  autoplay: PropTypes.bool,
  /** 是否在每个小宫格之间加边框 */
  border: PropTypes.bool,
  /** 每屏数量 */
  slidesPerView: PropTypes.number,
  /** 每屏行数 */
  slidesPerColumn: PropTypes.number,
  /** 数据源 */
  datas: PropTypes.array,
};

export default Carousel;
